import { jwtDecode } from 'jwt-decode';

// Émis quand le serveur refuse la session admin (compte supprimé, mot de passe changé ailleurs, token expiré)
export const ADMIN_SESSION_INVALID_EVENT = 'bluenote:admin-session-invalid';

// Affichage uniquement : l'autorisation est toujours vérifiée côté serveur
export const getAdminMatricule = () => {
  const token = sessionStorage.getItem('authToken');
  if (!token) return null;
  try {
    return jwtDecode(token).adminMatricule || null;
  } catch {
    return null;
  }
};

export const getAdminAuthHeaders = (headers = {}) => {
  const token = sessionStorage.getItem('authToken');
  return token ? { ...headers, Authorization: `Bearer ${token}` } : headers;
};

export const storeAdminSession = (token, expiresAt) => {
  sessionStorage.setItem('authToken', token);
  sessionStorage.setItem('authExpiration', String(expiresAt));
};

export const adminFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: getAdminAuthHeaders(options.headers)
  });
  if (response.status === 401) {
    window.dispatchEvent(new Event(ADMIN_SESSION_INVALID_EVENT));
  }
  return response;
};
